<template>
  <div id="app">
    <transition name="show-from-left">
      <popover name="helpbacklog" :width="240">
        <Help :titleChart="titleChart"> 
            <div slot="content">
               <p> {{ $t("129") }} </p>
            </div>     
          </Help>
      </popover>
    </transition>

    <div class="title-charts">{{ $t("130") }}
      <button class="bt-help" v-popover:helpbacklog.right><i class="icon-help ti-help-alt"></i></button>
    </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'
import { log } from 'fullcalendar';

export default {
  name: 'charts',

  props: {
    online: {
        type: Boolean
    }
  },
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("130"),
      tableData: [],
      chartOptions: {
        chart: {
          type: 'column',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                },
                overflow: false
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: this.$t("131"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
                events:{
                    click: this.loadGrid
                },
                cursor: 'pointer'
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px'
                }
            }
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: this.$t("132"),
            color: '#90ED7D',
            data: []

        }, {
            name: this.$t("133"),
            color: '#F45B5B',
            data: []

        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

      },
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){
      
    

    //console.log('this.online: ', this.online)
    let online = ''
    if (this.online == false){
        online = 0;


      let evento = event.point.series.name

    let filtro = ''
    if(evento == 'Fechado'){
        filtro = 'CLOSED';
    }
    if (evento == 'Atrasado'){
        filtro = 'PENDING';
    }
    if(evento == 'Closed'){
        filtro = 'CLOSED';
    }
    if (evento == 'Late'){
        filtro = 'PENDING';
    }
   
    let filter = !filtro ? event.point.series.name : filtro
   /* console.log('evento', evento)
    console.log('filter', filter)*/  

      let area_name = ''
      let planta = ''
      let plant_name = '';
      let region = ''

      if (this.filters.plant){
        planta = this.filters.plant;
        if(!this.filters.area){
            area_name = event.point.category;
        }
        plant_name = ''
        region = ''
      }
      
      else if (this.filters.region){
        planta = '';
        area_name = ''
        plant_name = event.point.category;
        region = this.filters.region
      } else {
        region = event.point.category;
      }


    
      /*console.log('area_name: ', area_name)
      console.log('planta: ', planta)
      console.log('plant_name: ', plant_name)
      console.log('region: ', region)*/

      let feedback = filter

      let NAME_CHART = event.point.category + ' - ' +`${evento.toUpperCase()}`;

      if (feedback == 'No data') return; 

      const ENDPOINT = `v1/mysemeq-ambev/get-pareto-rdps-grid?year=${this.filters.year}&period=${this.filters.period}&plant=${planta}&plant_name=${plant_name}&region=${region}&technique=${this.online ? '' : this.filters.technique}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&feedback_status=${feedback}&area_name=${area_name}&online=${online}`

     


      

      let grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
            "rows": '',
            "plant": this.$t("310"),
            "area": this.$t("311"),
            "sector": this.$t("312"),
            "component": this.$t("313"),
            "component_tag": this.$t("314"),
            "component_type_en": this.$t("315"),
            "machine": this.$t("316"),
            "machine_tag": this.$t("317"),
            "status_txt_en": this.$t("318"),
            "report_number": this.$t("319"), 
            "approved_datetime": this.$t("320"),
            "technique_en": this.$t("321"),
            "feedback_status_en" : this.$t("333"),
            "link": this.$t("323"),
            "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("354"),
        txtHelp: this.$t("355")
      }

      if (this.filters.plant) {
          delete grid.columns['plant']
      } 

      this.changeGrid(grid);


    }
    else{
        online = 1;


        let evento = event.point.series.name

    let filtro = ''
    if(evento == 'Fechado'){
        filtro = 'CLOSED';
    }
    if (evento == 'Atrasado'){
        filtro = 'PENDING';
    }
    if(evento == 'Closed'){
        filtro = 'CLOSED';
    }
    if (evento == 'Late'){
        filtro = 'PENDING';
    }
   
    let filter = !filtro ? event.point.series.name : filtro
   /* console.log('evento', evento)
    console.log('filter', filter)*/

        let area_name = ''
      let planta = ''
      let plant_name = '';
      let region = ''

      if (this.filtersOn.planta){
        planta = this.filtersOn.planta;
        if(!this.filtersOn.area){
            area_name = event.point.category;
        }
        plant_name = ''
        region = ''
      }
      
      else if (this.filtersOn.region){
        planta = '';
        area_name = ''
        plant_name = event.point.category;
        region = this.filtersOn.region
      } else {
        region = event.point.category;
      }


    
      /*console.log('area_name: ', area_name)
      console.log('planta: ', planta)
      console.log('plant_name: ', plant_name)
      console.log('region: ', region)*/

       let feedback = filter

      let NAME_CHART = event.point.category + ' - ' +`${evento.toUpperCase()}`;

      if (feedback == 'No data') return;

      const ENDPOINT = `v1/mysemeq-ambev/get-pareto-rdps-grid?year=${this.filtersOn.year}&period=${this.filtersOn.period}&plant=${planta}&plant_name=${plant_name}&region=${region}&technique=${this.online ? '' : this.filters.technique}&area=${this.filtersOn.area_f}&sector=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&component=${this.filtersOn.subset}&feedback_status=${feedback}&area_name=${area_name}&online=${online}`

     

      let grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
            "rows": '',
            "plant": this.$t("310"),
            "area": this.$t("311"),
            "sector": this.$t("312"),
            "component": this.$t("313"),
            "component_tag": this.$t("314"),
            "component_type_en": this.$t("315"),
            "machine": this.$t("316"),
            "machine_tag": this.$t("317"),
            "status_txt_en": this.$t("318"),
            "report_number": this.$t("319"), 
            "approved_datetime": this.$t("320"),
            "technique_en": this.$t("321"),
            "feedback_status_en" : this.$t("333"),
            "link": this.$t("323"),
            "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("354"),
        txtHelp: this.$t("355")
      }

      if (this.filtersOn.planta) {
          delete grid.columns['plant']
      } 

      this.changeGrid(grid);
    }

      

    },
    getData(){
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-pareto-rdps' 

      let filters = {};
      if(this.online){
        filters = this.filtersOn;
      } else {
        filters = this.filters;
      }

      filters['online'] = 0;
      if(this.online){
        filters['online'] = 1;
        filters['plant'] = filters['planta']
         filters['area'] = filters['area_f']
         filters['sector'] = filters['sector_f']
         filters['component'] = filters['subset']
      }

      this.$refs.chart.chart.showLoading();

      let self = this;
      axios({method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.tableData = resp.data;
        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      })
    },
    setChartData () {
        var self = this
        var res = self.tableData

        self.chartOptions.xAxis.categories = []
        self.chartOptions.series[0].data = [] // closed
        self.chartOptions.series[1].data = [] // late
        if(res) {
            res.forEach(function (it) {

              self.chartOptions.xAxis.categories.push(it[0])
             
              self.chartOptions.series[0].data.push(it[1]['FECHADO']|| 0)
            
              self.chartOptions.series[1].data.push(it[1]['PENDENTE'] || 0)
            })
        }
    },
  },
  computed: {
    ...mapGetters(['filters', 'filtersOn']),
  },
  watch: {
    filters: function(newValue){
      this.getData();
    },
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style scoped>
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 14px;*/
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

.bt-change-chart{
    top: -5px!important;
}

div[data-popover="helpbacklog"] {
    left: 60% !important;
    top: 10% !important;
}

.title-charts {
    margin-top: 30px;
    margin-bottom: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/ChartBacklog.vue